import React from 'react';
import { Formik } from 'formik';

import { CivilityList } from 'modules/shared/utils';
import { SubmitButton } from 'modules/shared-ui/components';
import {
    RadioInputControl,
    InputControl,
    DatePickerControl,
    EmailInputControl,
    CheckBoxInputControl,
    TextAreaControl,
    PhoneInputControl,
} from 'modules/shared-form/components';
import { buildCMSStyles } from 'modules/shared-cms/utils';
import { TextColorProps } from 'modules/shared-cms/cms-base-type';

import { GameFormProps, Participation } from './game-form-type';

import styles from './game-form-component.module.css';

export const GameForm: React.FC<GameFormProps> = ({ onSuccess, textColor }: GameFormProps) => {
    return (
        <React.Fragment>
            <Formik<Participation>
                initialValues={new Participation()}
                validateOnChange={false}
                onSubmit={values => {
                    onSuccess({ ...values });
                }}
                render={props => (
                    <form onSubmit={props.handleSubmit} style={buildCMSStyles<TextColorProps>({ textColor })}>
                        <div className={styles.dateLabel}>Civilité*</div>
                        <div className={styles.formLine}>
                            <RadioInputControl name="civility" required horizontal options={CivilityList} />
                        </div>
                        <div className={styles.formLine}>
                            <InputControl name="firstName" required placeholder="Prénom*" maxLength={28} />
                        </div>
                        <div className={styles.formLine}>
                            <InputControl name="lastName" required placeholder="Nom*" maxLength={28} />
                        </div>
                        <div className={`${styles.formLine} ${styles.date}`}>
                            <div className={styles.dateLabel}>Date d’événement*</div>
                            <div className={styles.datePicker}>
                                <DatePickerControl name="eventDate" required />
                            </div>
                        </div>
                        <div className={styles.formLine}>
                            <PhoneInputControl name="phone" required placeholder="Numéro de téléphone*" />
                        </div>
                        <div className={styles.formLine}>
                            <EmailInputControl name="email" required placeholder="Adresse e-mail*" />
                        </div>
                        <div className={styles.formLine}>
                            <TextAreaControl
                                name="city"
                                placeholder="Ville&#10;Votre Ville nous permet de vous adresser la communication correspondant à votre
                                résidence"
                                lightgray
                            />
                        </div>
                        <div className={styles.formLine}>
                            <div className={styles.postalCode}>
                                <TextAreaControl
                                    name="zipCode"
                                    placeholder="Code postal&#10;Votre Code Postal nous permet de vous adresser la communication correspondant à votre
                                résidence"
                                    maxLength={5}
                                    lightgray
                                />
                            </div>
                        </div>
                        <div className={styles.formLine}>
                            {/* <div className={styles.newsLetterCaption}>
                                <p>
                                    Je souhaite recevoir les offres et avantages <b>Printemps Listes</b>
                                </p>
                            </div> */}
                            <div className={styles.newsLetterOptions}>
                                <div className={styles.newsLetterOption}>
                                    <CheckBoxInputControl
                                        label="Je souhaite être informé de l'actualité Printemps Listes / Printemps Mariage"
                                        name="subscriptions.mariage"
                                    />
                                </div>
                                {/* <div className={styles.newsLetterOption}>
                                    <CheckBoxInputControl label="Naissance" name="subscriptions.naissance" />
                                </div>
                                <div className={styles.newsLetterOption}>
                                    <CheckBoxInputControl label="Cadeaux" name="subscriptions.cadeaux" />
                                </div>
                                <div className={styles.newsLetterOption}>
                                    <CheckBoxInputControl label="Voyage" name="subscriptions.voyage" />
                                </div>
                                <div className={styles.newsLetterOption}>
                                    <CheckBoxInputControl label="Robes" name="subscriptions.robes" />
                                </div> */}
                            </div>
                        </div>
                        <div className={styles.buttonContainer}>
                            <SubmitButton text="Participer" />
                        </div>
                    </form>
                )}
            />
        </React.Fragment>
    );
};
